import React, { forwardRef, useEffect, useRef } from 'react'
import styled from 'styled-components'

const Messages = forwardRef(({ message }, ref) => {
    const scrollRef = useRef(null);
    let date = new Date(message?.time).toLocaleDateString('en-GB');
    const time = new Date(message?.time)
    const currentDate = new Date().toLocaleDateString('en-GB');
    useEffect(() => {
        scrollRef?.current?.scrollIntoView({ behaviour: 'smooth' });
    }, [])
    const messageBody = (
        <div className={`message ${message?.fromSelf ? 'sended' : 'received'}`}>
            {message?.fromSelf && <div className='date-right'>{(date === currentDate && 'Today') || (new Date(message?.time).getTime() < new Date().getTime() && date)}</div>}
            <div className="content">
                <p className='single_message'>
                    {message?.message}
                </p>
                <p className='time'>{time.toLocaleTimeString('eu-US', { hour: '2-digit', minute: '2-digit' })}</p>
            </div>
            {!message?.fromSelf && <div className='date-left'>{(date === currentDate && 'Today') || (new Date(message?.time).getTime() < new Date().getTime() && date)}</div>}
        </div>
    )
    const content = ref
        ? <Wrapper ref={ref}>{messageBody}</Wrapper>
        : <Wrapper ref={scrollRef}>{messageBody}</Wrapper>
    return (
        content
    )
})

const Wrapper = styled.div`
    .message {
            display: flex;
            align-items: center;
        .content {
            max-width: 40%;
            min-width: 5rem;
            overflow-wrap: break-word;
            padding: 1rem;
            font-size: 1.1rem;
            border-radius: 1rem;
            color: #d1d1d1;
            position:relative ;
            .single_message{
                padding-bottom:3px ;
            }
            .time{
                display:none;
            }
            @media screen and (min-width: 720px) and (max-width: 1080px) {
                max-width: 70%;
            }
        }
        .date-left,.date-right{
            display:none ;
        }
    }
    .message:hover{
        .date-left,.date-right{
            display:inline;
            color:grey ;
            font-size:0.78rem ;
        }
        .date-left{
            margin-left:1rem ;
        }
        .date-right{
            margin-right:1rem ;
        }
        .time{
                position:absolute;
                display:flex ;
                justify-content:flex-end ;
                align-items:flex-end ;
                font-size:0.64rem;
                margin-right:1rem ;
                right:0;
                text-transform:lowercase ;
                color:#9a86f3;
            }
        }
        .sended {
            justify-content: flex-end;
            .content {
                background-color: #4f04ff21;
            }
        }
        .received {
            justify-content: flex-start;
            .content {
                background-color: #9900ff20;
            }
        }

`
export default Messages